import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      userManagement: {
        ...store.getState().i18n.translations.en.userManagement,
        orderManagement: {
          ORDER_MANAGEMENT: 'Order Management',
          ORDER_STATUS: 'Order Status',
          PAYMENT_STATUS: 'Payment Status',
          PAYMENT_METHOD: 'Payment Method',
          DATE_ORDERED: 'Date Ordered',
          ORDER_DESCRIPTION: 'Order Description',
          TOTAL: 'Total (VND)',
          DETAILS: 'Details',
          PAY_NOW: 'Pay Now',
          ALL_STATUS: 'All status',
          VOLUME: 'Volume',
          ORDER_TOTAL: 'Total: %{quantity} orders',
          PENDING: 'Pending',
          SUCCESS: 'Success',
          CHECKING: 'Checking',
          ERROR: 'Error',
          CANCELLED: 'Cancelled',
          COMPLETED: 'Completed',
          PROCESSING: 'Processing',
          FAILED: 'Failed',
          BANK_TRANSFERS: 'Bank Transfers',
          CARD: 'Card',
          PACKAGE: 'Package',
          POSTPAID: 'Post-paid',
          FREE: 'Free',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      userManagement: {
        ...store.getState().i18n.translations.vi.userManagement,
        orderManagement: {
          ORDER_MANAGEMENT: 'Quản Lý Đơn Hàng',
          ORDER_STATUS: 'Trạng Thái của Đơn Hàng',
          PAYMENT_STATUS: 'Trạng Thái Thanh Toán',
          PAYMENT_METHOD: 'Phương Thức Thanh Toán',
          DATE_ORDERED: 'Ngày Đặt Hàng',
          ORDER_DESCRIPTION: 'Mô Tả Đơn Hàng',
          TOTAL: 'Tổng Thanh Toán (VND)',
          DETAILS: 'Chi Tiết',
          PAY_NOW: 'Thanh Toán Ngay',
          ALL_STATUS: 'Tất cả',
          VOLUME: 'Số Lượng',
          ORDER_TOTAL: 'Tổng: %{quantity} đơn hàng',
          PENDING: 'Chờ Xử Lý',
          SUCCESS: 'Hoàn Thành',
          CHECKING: 'Đang Kiểm Tra',
          ERROR: 'Thất Bại',
          CANCELLED: 'Bị Huỷ',
          COMPLETED: 'Hoàn Thành',
          PROCESSING: 'Đang Xử Lý',
          FAILED: 'Thất Bại',
          BANK_TRANSFERS: 'Chuyển Khoản',
          CARD: 'Thẻ',
          PACKAGE: 'Gói',
          POSTPAID: 'Thanh toán sau',
          FREE: 'Miễn phí',
        },
      },
    },
  }),
)
